<div class="videocontainer">
  <div *ngFor="let node of nodeList">
    <app-videonode #nodelem [tile]="node.tile" [popin]="node.playback.context === PlaybackContext.POPIN"
      [pip]="node.playback.context === PlaybackContext.PIP" [position]="node.playback.position"
      [action]="node.playback.action">
    </app-videonode>
  </div>
</div>
